import { createSelector } from "@reduxjs/toolkit"

import { RootState } from "../reducers"

export const selectCurrentReferralCode = (state: RootState) =>
  state.referrals.currentReferralCode

export const selectReferralCodes = (state: RootState) =>
  state.referrals.referralCodes

export const selectReferralCodesLoaded = (state: RootState) =>
  !!state.referrals.referralCodes

export const selectReferralMats = createSelector(
  [selectReferralCodes],
  (referralCodes) =>
    referralCodes
      ? referralCodes.map(({ code, dailyMats, referralCount }) => ({
          code,
          dailyMats,
          referralCount,
        }))
      : [],
)

export const selectClaimedReferral = createSelector(
  [selectReferralMats, (_, code: string) => code],
  (referralMats, code) => {
    const referralCode = referralMats.find((referral) => referral.code === code)

    return referralCode
      ? {
          dailyMats: referralCode.dailyMats,
          referralCount: referralCode.referralCount,
        }
      : null
  },
)
